import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { Fragment, useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { ChipConnector } from '~/components/AiSearchChips/ChipConnector/ChipConnector';
import { moveQuantifier, nextQuantifier, presentServiceEntries, setQuantifier } from './service-predicate';
import { ServiceConditionChip } from './ServiceConditionChip/ServiceConditionChip';
import { isFlattenableCondition } from './serviceConditions';
import { ServiceFlattenedChips } from './ServiceFlattenedChips';
export const GetServicesChipsTID = (parentTestId)=>getTestIds(parentTestId);
export const ServicesChips = (param)=>{
    let { testId, services, onChange } = param;
    const { ServicesChipsTestIds } = useMemo(()=>GetServicesChipsTID(testId), [
        testId
    ]);
    const toggleQuantifier = (quantifier)=>{
        const target = nextQuantifier(services, quantifier);
        if (target === quantifier) return;
        onChange(moveQuantifier(services, quantifier, target));
    };
    const flattenedProps = (quantifier, predicate)=>({
            chipTestId: (field)=>ServicesChipsTestIds.Chip(quantifier, field),
            services,
            quantifier,
            predicate,
            onChange
        });
    const summaryProps = (quantifier, predicate)=>({
            testId: ServicesChipsTestIds.SummaryChip(quantifier),
            quantifier,
            predicate,
            onToggleQuantifier: ()=>toggleQuantifier(quantifier),
            onRemove: ()=>onChange(setQuantifier(services, quantifier, undefined))
        });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: presentServiceEntries(services).map((param, index)=>{
            let { quantifier, predicate } = param;
            return /*#__PURE__*/ _jsxs(Fragment, {
                children: [
                    index > 0 && /*#__PURE__*/ _jsx(ChipConnector, {
                        testId: ServicesChipsTestIds.AndConnector(index - 1),
                        tone: "and"
                    }),
                    isFlattenableCondition(predicate, quantifier) ? /*#__PURE__*/ _jsx(ServiceFlattenedChips, _object_spread({}, flattenedProps(quantifier, predicate))) : /*#__PURE__*/ _jsx(ServiceConditionChip, _object_spread({}, summaryProps(quantifier, predicate)))
                ]
            }, quantifier);
        })
    });
};
